import { render, staticRenderFns } from "./DOutsideLinkPreview.vue?vue&type=template&id=51e96af5&"
import script from "./DOutsideLinkPreview.vue?vue&type=script&lang=js&"
export * from "./DOutsideLinkPreview.vue?vue&type=script&lang=js&"
import style0 from "./DOutsideLinkPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports